import { differenceInCalendarDays } from 'date-fns';
import * as z from 'zod';
import { LicenceType } from '../database/schema.js';
export const LicenceStatus = z.enum(['upcoming', 'active', 'expiring', 'expired']);
export function determineLicenceStatus(licence) {
    const daysUntilStart = getDaysUntilLicenceStart(licence);
    if (daysUntilStart > 0)
        return LicenceStatus.enum.upcoming;
    const daysUntilExpiry = getDaysUntilLicenceExpiry(licence);
    if (daysUntilExpiry === Number.POSITIVE_INFINITY)
        return LicenceStatus.enum.active;
    if (daysUntilExpiry <= 0)
        return LicenceStatus.enum.expired;
    if (isLicenceExpiring(daysUntilExpiry))
        return LicenceStatus.enum.expiring;
    return LicenceStatus.enum.active;
}
export function isLicenceExpiring(daysUntilExpiry) {
    return daysUntilExpiry <= 7;
}
export function getDaysUntilLicenceStart(licence) {
    if (!licence || licence.type === LicenceType.enum.lifetime || !licence.issuedAt)
        return -1;
    const now = Date.now();
    const { issuedAt } = licence;
    const daysUntilStart = differenceInCalendarDays(issuedAt, now);
    return daysUntilStart;
}
export function getDaysUntilLicenceExpiry(licence) {
    if (!licence || licence.type === LicenceType.enum.lifetime || !licence.expiresAt)
        return Number.POSITIVE_INFINITY;
    const now = Date.now();
    const { expiresAt } = licence;
    const daysUntilExpiry = differenceInCalendarDays(expiresAt, now);
    return daysUntilExpiry;
}
export function redactLicenceJWT(jwt) {
    const length = jwt.length;
    const visibleLength = 6;
    return jwt.slice(0, visibleLength).padEnd(length / 12 - visibleLength, '*');
}
//# sourceMappingURL=licences.js.map